<style lang="less" scoped>
.formUl {
    >li {
        list-style: none;
        margin-bottom: 5px;
        >div {
            padding-left: 10px;
        }
    }
}
.cusTable {
    text-align: center;
}
.step {
    width: 30%;
    background:#6482AF;
    color: #FFF;
    padding: 8px 0;
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        box-shadow: 0 0 10px #6482AF;
    }
}
.stepIcon {
    width: 5%;
    display: flex;
    
    &::after {
        display: block;
        content:"";
        width: 20px;
        height: 20px;
        border-top: solid #000 2px;
        border-right: solid #000 2px;
        margin-left:10%;
        transform: rotate(32deg) skew(-20deg);
    }
}
.pt20 {
    padding: 20px 20px 0;
}
.stepAct {
    background: #10103d !important;
}
.orderLabel {
    width: 100px;
    text-align: right;
}
.proWrap {
    min-height:300px;
    >div:first-child {
        width: 20%;
        border-right: solid #999 2px;
        a {
            display: inline-block;
            border-bottom: solid 1px #5E94E5;
            margin-bottom: 8px;
            transition: 0.3s;
        }
    }
    >div:last-child {
        // padding-left: 20px;
        width: 80%;
    }
}
.proListWrap {
    // border: solid green 1px;
    width: 100%;
    >div {
        // border: solid red 1px;
        width: calc(25% - 2.7px);
        margin-left: 20px;
        min-height: 50px;
        float: left;
        margin-bottom: 20px;
    }
}
.proImg {
    width: 100%;
    height: 150px;
    border: solid #CCC 1px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    & + div{
        text-align: center;
        >span {
            color: #6482AF;
        }
    }
}
.numberBox {
    >div:first-child,>div:last-child {
        width: 25px;
        height: 25px;
        background: #C4C4C4;
        line-height: 25px;
        user-select: none;
        cursor: pointer;
        transition: 0.3s;
        &:hover {
            box-shadow: 0 0 5px #333;
        }
    }
    >input {
        margin: 0 5px;
        width: 50%;
        text-align: center;
        padding-left: 1em;
    }
}
.cateAct {
    >a {
        color: #10103d !important;
        font-weight: bold;
        border-bottom: solid #10103d 1px !important;
    }
    
}
.through {
    text-decoration: line-through;
    color: #999;
}
.priceBox {
    margin: 0px 0 0 0;
    width: 17.5%;
    text-align: center;
}
.greenBg {
    background: #15123E;
}
.purperBg {
    background: #532133;
}
.margin3 {
    margin: 8px 0;
}
.btn-group {
    button {
        width: 100%;
    }
}
.height3em {
    padding: 5px 0;
    height: 51px;
    overflow-y: auto;
}
.pre-label {
    display: block;
    width: 40px;
}
.width100 {
    width: 100px;
    margin-left: 15px;
}
.resBox {
    position: absolute;
    left: 0;
    top: 105%;
    background: #FFF;
    border-radius: 4px;
    box-shadow: 0 0 3px #CCC;
    max-height:200px;
    width: 100%;
    z-index: 100;
    overflow: auto;
}
.res-item {
    height: 30px;
    padding: 0 10px;
    // margin: 0 10%;
    // border-bottom: solid #CCC 1px;
    transition: 0.3s;
    &:hover {
        background: rgb(226, 225, 225);
    }
}
</style>

<template>
    <div>
        <h2 class="pageTitle">訂單列表</h2>

        <!-- 搜索Box -->
        <div class="sb searchBoxWrap">
            <div class="al">
                <div class="relative">
                    <Input type="text" style="width: 200px" 
                        placeholder="搜索訂單" @on-change="preSearch" 
                        @on-focus="focus"
                        @on-blur="blur"
                        clearabled v-model="keyword" clearable @on-clear="clear" /> 
                    <transition name="fade">
                        <div class="resBox" v-if="showRes">
                            <ul>
                                <li class="res-item al cursor op user-select" 
                                    @click="search(item)"
                                    v-for="(item,i) in options1" :key="i">{{item}}</li>
                            </ul>
                        </div>
                    </transition>
                    
                </div>

                <Select class="width100" v-model="status" placeholder="全部">
                    <Option value="0">全部狀態</Option>
                    <Option value="1">處理中</Option>
                    <Option value="2">已付款</Option>
                </Select>
                <Button type="primary" class="searchBtn" @click="showTable">搜索</Button>
            </div>
            <div>
                <Button type="info" @click="showAddModal">+ 創建新訂單</Button>
            </div>
        </div>

        <div class="tableWrap">
            <Table :columns="columns" :data="list" :searchable="false" border @on-row-click="showAnOrder" :loading="tableLoad">
                <template slot="action" slot-scope="{row}">
                    <div class="ju">
                        <Button type="warning" size='small' style="margin-right: 10px;" @click.stop.prevent="edit(row)">編輯</Button>
                        <Button type="error" size='small' @click.stop.prevent="del(row)">刪除</Button>
                    </div>
                </template>

                <template slot="amount" slot-scope="{row}">
                    <span>${{format( row.amount.toFixed(2) )}}</span>
                </template>

                <template slot="customer_id" slot-scope="{row}">
                    <span>{{ customer.find(item => item.id == row.customer_id) ? customer.find(item => item.id == row.customer_id).name : "" }}</span>
                </template>

                <template slot="status" slot-scope="{row}">
                    <span style="color:#6482AF;" v-if="row.status==1">處理中</span>
                    <span style="color: green;" v-if="row.status==2">已付款</span>
                </template>
            </Table>
        </div>

        <div class="PageWrap">
            <Page :current="page" :page-size="offset" :total="total" @on-change="changePage"></Page>
        </div>

        <!-- 詳情 -->
        <Modal v-model="showDetail" :width="900">
            <div slot="header" class="ModalHeader">
                <img src="@/assets/img/logo.png" width="180" alt="">
            </div>

            <div>
                <div class="flex">
                    <!-- 左 -->
                    <div style="flex:3.3">
                        <ul class="formUl">
                            <li class="al">
                                <span>客戶名稱:</span>
                                <div>
                                    <span>{{detail.customer.name}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>客戶編號:</span>
                                <div>
                                    <span>{{detail.customer.name_no}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>客戶種類:</span>
                                <div>
                                    <span>{{detail.customer.customer_type==1 ? "月結" : "現結"}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>聯繫人:</span>
                                <div>
                                    <span>{{detail.customer.contact_person}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>聯繫電話:</span>
                                <div>
                                    <span>{{detail.customer.phone}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>E-Mail:</span>
                                <div>
                                    <span>{{detail.customer.email}}</span>
                                </div>
                            </li>
                            
                            <li class="al">
                                <span>傳真:</span>
                                <div>
                                    <span>{{detail.customer.fax}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>地址:</span>
                                <div>
                                    <span>{{detail.customer.address}}</span>
                                </div>
                            </li>

                            <li class="al">
                                <span>PO.編碼:</span>
                                <div>
                                    <span>{{detail.POnum}}</span>
                                </div>
                            </li>
                            
                            
                        </ul>
                    </div>
                    <!-- 中 -->
                    <div style="flex:3.3">
                        <ul class="formUl">
                            <li class="al">
                                <span>訂單編號:</span>
                                <div>
                                    <span>{{detail.order_code}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>創建日期:</span>
                                <div>
                                    <span>{{detail.createAt}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>送貨日期:</span>
                                <div>
                                    <span>{{detail.deliveryAt}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>支付日期:</span>
                                <div>
                                    <span>{{detail.payAt}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>折扣率:</span>
                                <div>
                                    <span>{{detail.discount_rate}}%</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>華潤貨品提取號:</span>
                                <div>
                                    <span>{{detail.crl_pickUpNumber}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>嘉里貨品提取號:</span>
                                <div>
                                    <span>{{detail.kerry_pickUpNumber}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>狀態:</span>
                                <div>
                                    <span style="color: #6482AF;" v-if="detail.status==1">處理中</span>
                                    <span style="color: green;" v-if="detail.status==2">已付款</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>訂單跟進同事:</span>
                                <div>
                                    <span>{{detail.principal}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>備註:</span>
                                <div>
                                    <span>{{detail.remark}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- 右 -->
                    <div style="flex:3.3">
                        <div class="btn-group" v-if="!downloadLoading">
                            <Button class="greenBg margin3" type="primary" @click="exportCsv1('kerry')">嘉里提貨單下載</Button><br>
                            <Button type="warning" class="margin3" @click="exportCsv1('crl')">華潤提貨單下載</Button><br>
                            <Button type="info" class="margin3 purperBg" @click="exportCsv2">送貨單下載</Button>
                            <Button type="info" class="margin3" @click="exportCsv">下載</Button>
                        </div>
                    </div>
                </div>
                <div>
                    <myTable :columns="columns2" :list="detail.order_detail" :maxHeight="300" :searchable="false" ref="myTable">
                        <template slot="calc" slot-scope="{row}">
                            <span>${{format((row.count * row.price).toFixed(2))}}</span>
                        </template>
                    </myTable>
  
                    <div style="transform: translateY(20px)">
                        <div class="flex-end">
                            總計:
                            <span class="through priceBox"> ${{format( detail.amount ?  detail.amount / ((100 - detail.discount_rate)/100) : 0 )}}</span>
                        </div>
                        <div class="flex-end">
                            折扣:
                            <p class="priceBox" >{{detail.discount_rate}}%</p>
                        </div>
                        <div class="flex-end">
                            折扣後價格:
                            <p class="priceBox"> ${{format( detail.amount ? detail.amount.toFixed(2) : 0 )}}</p>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div slot="footer"> </div>
        </Modal>

        <!-- 創建 -->
        <Modal v-model="showAdd" :width="1000">
            <div slot="header" class="al size20 pt20">
                <div :class="['step', { stepAct: step >=1  }]" @click="changeStep(1)">1.訂單基本資料</div>
                <div class="stepIcon"></div>
                <div :class="['step', { stepAct: step >=2  }]" @click="changeStep(2)">2.添加產品</div>
                <div class="stepIcon"></div>
                <div :class="['step', { stepAct: step >=3  }]" @click="changeStep(3)">3.確認訂單</div>
            </div>

            <div style="padding: 0 20px;">
                <!-- 第一步 -->
                <div v-show="step==1">
                    <Form :model="addForm" ref="addForm" :rules="rules" :label-width="140">
                        <div class="ju">
                            <div style="flex: 5">
                                <FormItem label="客戶名稱:" prop="name">
                                    <Select type="text" v-model="addForm.name" 
                                        filterable
                                        not-found-text="無匹配數據"
                                        placeholder=" "
                                        style="width: 250px;">
                                        <Option v-for="(item,i) in customer" :key="i" :value="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="訂單編號:" prop="order_code">
                                    <div class="al">
                                        <span class="pre-label">WCI-</span>
                                        <Input type="text" v-model="addForm.order_code" style="width: 210px;" />

                                    </div>
                                </FormItem>
                                <FormItem label="創建日期:" prop="create_time">
                                    <DatePicker type="date" :value='addForm.create_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'addForm','create_time')" style="width: 250px;" />
                                </FormItem>

                                <FormItem label="送貨日期:" prop="delivery_time">
                                    <DatePicker type="date" :value='addForm.delivery_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'addForm','delivery_time')" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="支付日期:" prop="pay_time">
                                    <DatePicker type="date" :value='addForm.pay_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'addForm','pay_time')" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="PO.編碼:" prop="POnum">
                                    <Input type="text" v-model="addForm.POnum" style="width: 250px;" />
                                </FormItem>
                                
                            </div>
                            <div style="flex: 5">
                                <FormItem label="折扣率(%):" prop="discount_rate">
                                    <Input type="number" v-model="addForm.discount_rate" @on-change="fixNumber($event,'addForm')" placeholder="0 ~ 100" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="華潤貨品提取號:" prop="crl_pickUpNumber">
                                    <Input type="text" v-model="addForm.crl_pickUpNumber" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="嘉里貨品提取號:" prop="kerry_pickUpNumber">
                                    <Input type="text" v-model="addForm.kerry_pickUpNumber" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="訂單跟進同事:" prop="principal">
                                    <Input type="text" v-model="addForm.principal" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="狀態:" prop="status">
                                    <Select v-model="addForm.status"  style="width: 250px;">
                                        <Option value="1">處理中</Option>
                                        <Option value="2">已付款</Option>
                                    </Select>
                                </FormItem>

                                <FormItem label="備註:">
                                    <textarea v-model="addForm.remark" style="width: 250px;padding:5px 10px;"></textarea>
                                </FormItem>
                            </div>
                        </div>
                        
                        
                    </Form>
                </div>
                <!-- 第二步 -->
                <div v-show="step==2" class="proWrap flex">
                    <div>
                        <div class="noData" v-if="categories.length===0">暫無產品分類</div>
                        <ul>
                            <li v-for="(item,i) in categories" :key="i" :class="[{cateAct:i===cateAct}]" @click="changeCategory(i)">
                                <a>{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div class="clearBoth proListWrap">
                            <p class="noData" v-if="categories.length===0 || (categories[cateAct] ? categories[cateAct].commodity : []).length===0">暫無產品</p>
                            <div v-for="(item,i) in categories[cateAct] ? categories[cateAct].commodity : []" :key="i">
                                <div class="proImg" :style="{'background-image': `url(${ item.img  })`}"></div>
                                <div>
                                    <h3>{{item.name}}</h3>
                                    <span class="size12">{{item.sku}}</span>
                                    <div>庫存: <span class="priColor">{{item.store}}</span> </div>
                                    <p class="height3em bar">{{item.remark}}</p>

                                    <div class="numberBox ju al">
                                        <div class="op" @click="addSub(i,1)">-</div>
                                        <input type="number" @input="addSub(i,3)" :max='item.store' v-model="item.count" />
                                        <div class="op" @click="addSub(i,2)">+</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 第三步 -->
                <div v-show="step==3">
                    <div class="ModalHeader">
                        <img src="@/assets/img/logo.png" width="180" alt="">
                    </div>

                    <div>
                        <div class="flex">
                            <!-- 左 -->
                            <div style="flex:3.3">
                                <ul class="formUl">
                                    <li class="al">
                                        <span>客戶名稱:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).name : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>客戶編號:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).name_no : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>客戶種類:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).customer_type==1?"月結":"現結"
                                                : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>聯繫人:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).contact_person : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>聯繫電話:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).phone : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>E-Mail:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).email : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>傳真:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).fax : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>地址:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == addForm.name) ? 
                                                customer.find(item => item.id == addForm.name).address : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>PO.編碼:</span>
                                        <div>
                                            <span>{{addForm.POnum}}</span>
                                        </div>
                                    </li>
                                    
                                </ul>
                            </div>
                            <!-- 中 -->
                            <div style="flex:3.3">
                                <ul class="formUl">
                                    <li class="al">
                                        <span>訂單編號:</span>
                                        <div>
                                            <span>WCI-{{addForm.order_code}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>創建日期:</span>
                                        <div>
                                            <span>{{addForm.create_time}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>送貨日期:</span>
                                        <div>
                                            <span>{{addForm.delivery_time}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>支付日期:</span>
                                        <div>
                                            <span>{{addForm.pay_time}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>折扣率:</span>
                                        <div>
                                            <span>{{addForm.discount_rate * 1}}%</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>華潤貨品提取號:</span>
                                        <div>
                                            <span>{{addForm.crl_pickUpNumber}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>嘉里貨品提取號:</span>
                                        <div>
                                            <span>{{addForm.kerry_pickUpNumber}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>狀態:</span>
                                        <div>
                                            <span style="color: #6482AF;" v-if="addForm.status==1">處理中</span>
                                            <span style="color: green;" v-if="addForm.status==2">已付款</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>訂單跟進同事:</span>
                                        <div>
                                            <span>{{addForm.principal}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>備註:</span>
                                        <div>
                                            <span>{{addForm.remark}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!-- 右 -->
                            <div style="flex:3.3"></div>
                        </div>
                        <div>
                            <myTable :columns="columns2" :list="commodity" :maxHeight="300" :searchable="false" ref="myTable">
                                <template slot="calc" slot-scope="{row}">
                                    <span>${{format((row.count * row.price).toFixed(2))}}</span>
                                </template>
                            </myTable>

                            <div style="transform: translateY(20px)">
                                <div class="flex-end">
                                    總計:
                                    <span class="through priceBox"> ${{format( totalPrice )}}</span>
                                </div>
                                <div class="flex-end">
                                    折扣:
                                    <p class="priceBox" >{{addForm.discount_rate}}%</p>
                                </div>
                                <div class="flex-end">
                                    折扣後價格:
                                    <p class="priceBox"> ${{format( totalPrice - totalPrice * addForm.discount_rate/100 )}}</p>
                                </div>
                                
                            </div>
        
                        </div>
                        <br>
                    </div>
                </div>

            </div>

            <div slot="footer" class="flex-end ModalBtn">
                <Button type="error" size="small" @click="showAdd=false">取消</Button>
                <Button type="primary" size="small" @click="next(step + 1)" :loading='load'>{{step < 3 ? '下一步' : "儲存訂單"}} </Button>
            </div>
        </Modal>
        <!-- 編輯 -->
        <Modal v-model="showEdit" :width="1000">
            <div slot="header" class="al size20 pt20">
                <div :class="['step', { stepAct: step >=1  }]" @click="changeStep(1)">1.訂單基本資料</div>
                <div class="stepIcon"></div>
                <div :class="['step', { stepAct: step >=2  }]" @click="changeStep(2)">2.添加產品</div>
                <div class="stepIcon"></div>
                <div :class="['step', { stepAct: step >=3  }]" @click="changeStep(3)">3.確認訂單</div>
            </div>

            <div style="padding: 0 20px;">
                <!-- 第一步 -->
                <div v-show="step==1">
                    <Form :model="editForm" ref="editForm" :rules="rules" :label-width="140">
                        <div class="ju">
                            <div style="flex: 5">
                                <FormItem label="客戶名稱:" prop="name">
                                    <Select type="text" v-model="editForm.name" 
                                        not-found-text="無匹配數據"
                                        placeholder=" "
                                        filterable style="width: 250px;" >
                                        <Option v-for="(item,i) in customer" :key="i" :value="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="訂單編號:" prop="order_code">
                                    <Input type="text" v-model="editForm.order_code" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="創建日期:" prop="create_time">
                                    <DatePicker type="date" :value='editForm.create_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'editForm','create_time')" style="width: 250px;" />
                                </FormItem>

                                <FormItem label="送貨日期:" prop="delivery_time">
                                    <DatePicker type="date" :value='editForm.delivery_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'editForm','delivery_time')" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="支付日期:" prop="pay_time">
                                    <DatePicker type="date" :value='editForm.pay_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'editForm','pay_time')" style="width: 250px;" />
                                </FormItem>

                                <FormItem label="PO.編碼:" prop="POnum">
                                    <Input type="text" v-model="editForm.POnum" style="width: 250px;" />
                                </FormItem>
                                
                            </div>
                            <div style="flex: 5">
                                <FormItem label="折扣率(%):" prop="discount_rate">
                                    <Input type="text" v-model="editForm.discount_rate" placeholder="0 ~ 100" @on-change="fixNumber($event,'editForm')" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="華潤貨品提取號:" prop="crl_pickUpNumber">
                                    <Input type="text" v-model="editForm.crl_pickUpNumber" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="嘉里貨品提取號:" prop="kerry_pickUpNumber">
                                    <Input type="text" v-model="editForm.kerry_pickUpNumber" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="訂單跟進同事:" prop="principal">
                                    <Input type="text" v-model="editForm.principal" style="width: 250px;" />
                                </FormItem>
                                <FormItem label="狀態:" prop="status">
                                    <Select v-model="editForm.status"  style="width: 250px;">
                                        <Option value="1">處理中</Option>
                                        <Option value="2">已付款</Option>
                                    </Select>
                                </FormItem>

                                <FormItem label="備註:">
                                    <textarea v-model="editForm.remark" style="width: 250px;padding:5px 10px;"></textarea>
                                </FormItem>
                            </div>
                        </div>
                        
                        
                    </Form>
                </div>
                <!-- 第二步 -->
                <div v-show="step==2" class="proWrap flex">
                    <div>
                        <div class="noData" v-if="categories.length===0">暫無產品分類</div>
                        <ul>
                            <li v-for="(item,i) in categories" :key="i" :class="[{cateAct:i===cateAct}]" @click="changeCategory(i)">
                                <a>{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div class="clearBoth proListWrap">
                            <p class="noData" v-if="categories.length===0 || (categories[cateAct] ? categories[cateAct].commodity : []).length===0">暫無產品</p>
                            <div v-for="(item,i) in categories[cateAct] ? categories[cateAct].commodity : []" :key="i">
                                <div class="proImg" :style="{'background-image': `url(${  item.img == null? item.img != null  : noImg })`}"></div>
                                <div>
                                    <h3>{{item.name}}</h3>
                                    <span class="size12">{{item.sku}}</span>
                                    <div>庫存: <span class="priColor">{{item.store}}</span> </div>
                                    <p class="height3em bar">{{item.remark}}</p>

                                    <div class="numberBox ju al">
                                        <div class="op" @click="addSub(i,1)">-</div>
                                        <input type="number" @input="addSub(i,3)" :max='item.store' v-model="item.count" />
                                        <div class="op" @click="addSub(i,2)">+</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 第三步 -->
                <div v-show="step==3">
                    <div class="ModalHeader">
                        <img src="@/assets/img/logo.png" width="180" alt="">
                    </div>

                    <div>
                        <div class="flex">
                            <!-- 左 -->
                            <div style="flex:3.3">
                                <ul class="formUl">
                                    <li class="al">
                                        <span>客戶名稱:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).name : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>客戶編號:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).name_no : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>客戶種類:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).customer_type==1?"月結":"現結"
                                                : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>聯繫人:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).contact_person : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>聯繫電話:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).phone : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>E-Mail:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).email : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>傳真:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).fax : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>地址:</span>
                                        <div>
                                            <span>{{ 
                                                customer.find(item => item.id == editForm.name) ? 
                                                customer.find(item => item.id == editForm.name).address : ""
                                            }}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>PO.編碼:</span>
                                        <div>
                                            <span>{{editForm.POnum}}</span>
                                        </div>
                                    </li>
                                    
                                </ul>
                            </div>
                            <!-- 中 -->
                            <div style="flex:3.3">
                                <ul class="formUl">
                                    <li class="al">
                                        <span>訂單編號:</span>
                                        <div>
                                            <span>WCI-{{editForm.order_code}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>創建日期:</span>
                                        <div>
                                            <span>{{editForm.create_time}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>送貨日期:</span>
                                        <div>
                                            <span>{{editForm.delivery_time}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>支付日期:</span>
                                        <div>
                                            <span>{{editForm.pay_time}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>折扣率:</span>
                                        <div>
                                            <span>{{editForm.discount_rate * 1}}%</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>華潤貨品提取號:</span>
                                        <div>
                                            <span>{{editForm.crl_pickUpNumber}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>嘉里貨品提取號:</span>
                                        <div>
                                            <span>{{editForm.kerry_pickUpNumber}}</span>
                                        </div>
                                    </li>
                                    
                                    <li class="al">
                                        <span>狀態:</span>
                                        <div>
                                            <span style="color: #6482AF;" v-if="editForm.status==1">處理中</span>
                                            <span style="color: green;" v-if="editForm.status==2">已付款</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>訂單跟進同事:</span>
                                        <div>
                                            <span>{{editForm.principal}}</span>
                                        </div>
                                    </li>
                                    <li class="al">
                                        <span>備註:</span>
                                        <div>
                                            <span>{{editForm.remark}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!-- 右 -->
                            <div style="flex:3.3"></div>
                        </div>
                        <div>
                            <myTable :columns="columns2" :list="commodity" :maxHeight="300" :searchable="false" ref="myTable">
                                <template slot="calc" slot-scope="{row}">
                                    <span>${{format((row.count * row.price).toFixed(2))}}</span>
                                </template>
                            </myTable>
        
                            <div style="transform: translateY(20px)">
                                <div class="flex-end">
                                    總計:
                                    <span class="through priceBox"> ${{format( totalPrice )}}</span>
                                </div>
                                <div class="flex-end">
                                    折扣:
                                    <p class="priceBox" >{{editForm.discount_rate}}%</p>
                                </div>
                                <div class="flex-end">
                                    折扣後價格:
                                    <p class="priceBox"> ${{format( totalPrice - totalPrice * editForm.discount_rate/100 )}}</p>
                                </div>
                                
                            </div>
                        </div>
                        <br>
                    </div>
                </div>

            </div>

            <div slot="footer" class="flex-end ModalBtn">
                <Button type="error" size="small" @click="showEdit=false">取消</Button>
                <Button type="primary" size="small" @click="next(step + 1)" :loading='load'>{{step<3 ? '下一步' : "編輯"}} </Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import noImg from "@/assets/img/noImg.png"
export default {
    data () {
        return {
            columns: [
                { title: "編號", key: "id", sortable: true, align:"center", width: 100 },
                { title: "訂單編號", key: "order_code", sortable: true, align:"center" },
                { title: "折扣率(%)", key: "discount_rate", sortable: true, align:"center" },
                { title: "總金額", key: "amount", sortable: true, align:"center", slot: "amount" },
                { title: "客戶名稱", slot: "customer_id", sortable: true, align:"center" },
                // { title: "嘉里貨品提取號", key: "crl_pickUpNumber", sortable: true, align:"center" },
                { title: "創建日期", key: "createAt", sortable: true, align:"center" },
                { title: "狀態", key: "status", sortable: true, align:"center", slot: "status" },
                { title: "操作", slot: "action", align:"center" },
            ],
            list: [],
            keyword: "",
            keyword1: "",
            page: 1,
            total: 0,
            showAdd: false,
            showEdit: false,
            showDetail: false,
            addForm: {
                name: "", 
                order_code: "",
                create_time: "",
                delivery_time: "", 
                principal: "",
                pay_time: '', 
                status:"1", 
                remark: "",
                discount_rate: "",
                crl_pickUpNumber: "",
                kerry_pickUpNumber: "",
                POnum: "",
            },
            editForm: {
                name: "", 
                order_code: "",
                create_time: "",
                delivery_time: "", 
                principal: "",
                pay_time: '', 
                status:"", 
                remark: "",
                discount_rate: "",
                crl_pickUpNumber: "",
                kerry_pickUpNumber: "",
                POnum: "",
            },
            rules: {
                name: [
                    { required: "true", message: "請選擇客戶"}
                ],
                order_code: [
                    { required: "true", message: "請輸入訂單編號", trigger: "blur" }
                ],
                create_time: [
                    { required: "true", message: "請選擇創建日期", trigger: "blur" }
                ],
                delivery_time: [
                    { required: "true", message: "請選擇過期日期", trigger: "blur" }
                ],
                principal: [
                    { required: "true", message: "請輸入訂單跟進同事", trigger: "blur" }
                ],
                pay_time: [
                    { required: "true", message: "請選擇支付日期", trigger: "blur" }
                ],
                status: [
                    { required: "true", message: "請選擇狀態", trigger: "blur" }
                ],
                // discount_rate: [
                //     { required: "true", message: "請輸入折扣", trigger: "blur" }
                // ],
                // kerry_pickUpNumber: [
                //     { required: "true", message: "請输入嘉里貨品提取號", trigger: "blur" }
                // ],
                // crl_pickUpNumber: [
                //     { required: "true", message: "請输入華潤貨品提取號", trigger: "blur" }
                // ],
                // POnum: [
                //     { required: "true", message: "請输入PO.編碼", trigger: "blur" }
                // ],
            },
            load: false,
            
            //訂單詳情
            columns2: [
                { title: "產品分類名稱", key:"category" },
                { title: "產品名稱", key:"name" },
                { title: "產品編號", key:"sku" },
                { title: "數量", key:"count" },
                { title: "單價", key:"price" },
                { title: "備註", key:"remark" },
                { title: "小計", key:"calc", slot: "calc" },
            ],
            detail: {
                order_detail: [],
                customer: {}
            },
            step: 1,
            cateAct: 0,
            categories: [],
            categories: [],
            commodity: [],    // 已選擇的產品
            downloadLoading: false,
            tableLoad: false,
            customer: [],
            noImg: "",
            status: "0",
            loading1: false, 
            options1: [],
            showRes: false,
        }
    },

    computed: {
        role () { return this.$store.state.role },
        offset () { return this.$store.state.offset },
        totalPrice () {
            let total = 0
            this.commodity.forEach(item => {
                total += item.count * item.price
            })
            return total.toFixed(2)
        },
    },
    created () {
        if (this.role == 2) {
            this.columns.pop()
        }
        this.initaddFormData()
        this.showTable()
        this.getCate()
        this.getClient()
        this.noImg = noImg
    },
    methods:{
        clear () {
            this.keyword1 = ""
            this.options1 = []

        },
        focus () {
            this.showRes = true
        },
        blur () {
            this.showRes = false
        },
        preSearch () {
            if (this.keyword) {
                this.keyword1 = this.keyword
                this.$axios({
                    url: "admin/order",
                    params: {
                        way: "1",
                        search: this.keyword
                    }
                }).then(res => {
                    this.options1 = res.data.data
                })
            } else {
                this.options1 = []
            }
            
        },
        exportCsv1 (name) {
            window.location.href = this.$axios.defaults.baseURL + "admin/download_logistics?uuid=" + this.detail.uuid + "&ways=" + name
        },
        getClient () {
            this.$axios({
                url: "admin/customer/",
                params: {
                    page: 1,
                    offset: 999999,
                }
            }).then(res => {
                if (res.data.code == 200) {
                    res.data.data.forEach(item => {
                        item.id = item.id + ""
                    })
                    this.customer = res.data.data
                } else {
                    this.customer = []
                }
            })
        },
        fixNumber (e, form) {
            let val = this[form].discount_rate * 1
            // console.log(val)
            if (val < 0) {
                this[form].discount_rate = "0"
            }
            if (val > 100) {
                this[form].discount_rate = "100"
            }
        },
        //獲取商品
        getComm (cate) {
            this.$axios({
                url: "admin/commodity",
                method: "GET",
                params: {
                    category_id: cate.uuid
                }
            }).then(res => {
                if (res.data.data) {
                    res.data.data.forEach(item => {
                        item.count = 0
                        item.category = cate.name
                    })
                    cate.commodity = res.data.data
                }
                this.categories = [...this.categories]
            })
        },
        changeCategory (i) {
            this.cateAct = i
            // this.getComm(this.categories[i].uuid)
        },
        //增加減少產品
        addSub (i,boo) {
            let commodity = this.categories[this.cateAct].commodity[i]
            if (boo===1) {
                //點擊減
                commodity.count--
                
            } else if (boo === 2) {
                //點擊加
                commodity.count++
                
            }

            if (commodity.count <= 0) {
                commodity.count = 0
            }
            if (commodity.count >= commodity.store) {
                commodity.count = commodity.store
            }
            commodity.count = Number(commodity.count)

            if (!this.commodity.find(c=>c.id == commodity.id)) {
                this.commodity.push(commodity)
            } else {
                let index = this.commodity.findIndex(c => c.id == commodity.id)
                this.commodity.splice(index,1,commodity)
            }
            this.commodity = this.commodity.filter(c => c.count > 0)
            this.categories = [...this.categories]
        },
        search (item) {
            this.page = 1
            this.keyword1 = item
            this.keyword = item
            // this.showTable()
        },
        showTable () {
            this.tableLoad = true
            this.$axios({
                url: "admin/order",
                params: {
                    page: this.page,
                    offset: this.offset,
                    search: this.keyword1,
                    status: this.status === "0" ? "" : this.status
                }
            }).then(res => {
                console.log(res)
                this.tableLoad = false
                if (res.data.data) {
                    this.list = res.data.data
                    this.total = res.data.count
                    if (res.data.data.length == 0 && this.page > 1) {
                        this.page--
                        this.showTable()
                    }
                } else {
                    this.list = []
                    this.total = 0
                }
            }).catch(e => {
                console.log(e)
                this.tableLoad = false
                this.$Message.error("網絡錯誤, 請稍後再試")
            })
        },
        //顯示一個訂單詳情
        showAnOrder (e) {
            this.showDetail = true
            this.detail = e
        },
        // 初始化創建時間和過期時間和隨機訂單編號
        initaddFormData () {
            let now = new Date()
            let ex = new Date( Date.now() + 611800000 )

            let y1 = now.getFullYear()
            let m1 = now.getMonth() + 1
            m1 = m1 < 10 ? '0' + m1 : m1
            let d1 = now.getDate()
            d1 = d1 < 10 ? '0' + d1 : d1
            this.addForm.create_time = y1 + "-" + m1 + "-" + d1

            let y2 = ex.getFullYear()
            let m2 = ex.getMonth() + 1
            m2 = m2 < 10 ? '0' + m2 : m2
            let d2 = ex.getDate()
            d2 = d2 < 10 ? '0' + d2 : d2
            this.addForm.delivery_time = y2 + "-" + m2 + "-" + d2

            // this.addForm = JSON.parse(JSON.stringify(this.addForm))

            let order_code = ''
            for (var i = 0; i < 6; i++) {
                order_code += Math.floor(Math.random() * 10);
            }
            order_code = 'D' + new Date().getTime() + order_code
            // this.addForm.order_code = order_code
        },
        // 創建訂單點擊下一步
        next (e) {
            let that = this
            if (e==2) {
                if (this.showAdd) {
                    this.$refs.addForm.validate(flag => {
                        if (flag) {
                            that.step = e
                        }
                    })
                }
                if (this.showEdit) {
                    this.$refs.editForm.validate(flag => {
                        if (flag) {
                            that.step = e
                        }
                    })
                }
            }
            else if (e == 3) {
                that.step = e
            }
            //最後一步點確定
            else if (e == 4) {
                if (this.showAdd) {
                    this.okAdd()
                } else if (this.showEdit) {
                    this.okEdit()
                }
            }
        },
        changePage (e) {
            this.page = e
            this.showTable()
        },
        okAdd () {
            let that =this
            this.$refs.addForm.validate(flag => {
                if (flag) {
                    if (that.commodity.length) {
                        that.load = true
                        that.$axios({
                            url: "admin/order",
                            method:"POST",
                            data: {
                                order_code: "WCI-" + that.addForm.order_code,
                                customer_id: that.addForm.name,
                                // amount: that.addForm.amount,
                                status: that.addForm.status * 1,
                                num: 1,
                                principal: that.addForm.principal,
                                create_time: that.addForm.create_time,
                                delivery_time: that.addForm.delivery_time,
                                pay_time: that.addForm.pay_time,
                                remark: that.addForm.remark,
                                order_detail: that.commodity,
                                discount_rate: that.addForm.discount_rate * 1,
                                crl_pickUpNumber: that.addForm.crl_pickUpNumber,
                                kerry_pickUpNumber: that.addForm.kerry_pickUpNumber,
                                POnum: that.addForm.POnum,
                            }
                        }).then(res => {
                            that.load = false
                            if (res.data.code == 200) {
                                that.$Message.success("創建成功")
                                that.showTable()
                                that.$refs.addForm.resetFields()
                                that.addForm.remark = ''
                                that.categories.forEach(c => {
                                    c.commodity.forEach(comm => { comm.count = 0 })
                                })
                                that.commodity = []
                                that.showAdd = false
                                that.step = 1
                            } else {
                                that.$Message.warning(res.data.data.msg)
                            }
                            that.getCate()
                        }).catch(e => {
                            console.log(e)  
                            that.load = false
                            that.$Message.error("網絡錯誤, 請稍後再試")
                        })
                    } else {
                        that.step = 2
                        that.$Message.warning("請添加產品")
                    }
                } else {
                    that.step = 1
                }
            })
        },
        okEdit () {
            let that =this
            this.$refs.editForm.validate(flag => {
                if (flag) {
                    if (that.commodity.length) {
                        that.load = true
                        that.$axios({
                            url: "admin/order",
                            method:"PUT",
                            data: {
                                uuid: that.editForm.uuid,
                                order_code: "WCI-" + that.editForm.order_code,
                                customer_id: that.editForm.name,
                                // amount: that.editForm.amount,
                                status: that.editForm.status * 1,
                                num: 1,
                                principal: that.editForm.principal,
                                create_time: that.editForm.create_time,
                                delivery_time: that.editForm.delivery_time,
                                pay_time: that.editForm.pay_time,
                                remark: that.editForm.remark,
                                order_detail: that.commodity,
                                discount_rate: that.editForm.discount_rate * 1,
                                crl_pickUpNumber: that.editForm.crl_pickUpNumber + "",
                                kerry_pickUpNumber: that.editForm.kerry_pickUpNumber + "",
                                POnum: that.editForm.POnum,

                            }
                        }).then(res => {
                            that.load = false
                            if (res.data.code == 200) {
                                that.$Message.success("編輯成功")
                                that.showTable()
                                that.$refs.editForm.resetFields()
                                that.editForm.remark = ''
                                that.categories.forEach(c => {
                                    c.commodity.forEach(comm => { comm.count = 0 })
                                })
                                that.commodity = []
                                that.showEdit = false
                                that.step = 1
                                that.getCate()
                            } else {
                                that.$Message.warning(res.data.data.msg)
                            }
                        }).catch(e => {
                            console.log(e)  
                            that.load = false
                            that.$Message.error("網絡錯誤, 請稍後再試")
                        })
                    } else {
                        that.step = 2
                        that.$Message.warning("請添加產品")
                    }
                } else {
                    that.step = 1
                }
            })
        },
        showAddModal () {
            this.commodity = []
            this.showAdd = true
            this.step = 1   
            // this.$refs.addForm.resetFields()
            this.categories.forEach(cate => {
                cate.commodity.forEach(c => {
                    c.count = 0
                })
            })
            this.cateAct = 0
            this.categories = [...this.categories]
        },
        edit (item) {
            this.editForm.uuid = item.uuid,
            this.editForm.name = item.customer_id + ""
            this.editForm.order_code = item.order_code.slice(4)
            this.editForm.create_time = item.createAt
            this.editForm.delivery_time = item.deliveryAt
            this.editForm.pay_time = item.payAt
            this.editForm.principal = item.principal
            this.editForm.status = item.status + ""
            this.editForm.remark = item.remark
            this.editForm.POnum = item.POnum
            this.editForm.discount_rate = item.discount_rate + ""
            this.editForm.crl_pickUpNumber = item.crl_pickUpNumber + ""
            this.editForm.kerry_pickUpNumber = item.kerry_pickUpNumber + ""
            this.showEdit = true
            this.step = 1  
            this.commodity = item.order_detail
            this.cateAct = 0
            this.categories.forEach(cate => {
                cate.commodity.forEach(c => {
                    c.count = 0
                    item.order_detail.forEach(comm => {
                        if (c.id == comm.id) {
                            c.count = comm.count

                        }
                    })
                })
            })
            this.categories = [...this.categories]
            
        },
        del (item) {
            let that = this
            that.$Modal.confirm({
                title: '提示',
                content : "確定刪除這條信息?",
                onOk () {
                    that.$axios({
                        url: "admin/order",
                        method:"DELETE",
                        data: {
                            uuid: item.uuid,
                            order_code: item.order_code
                        }
                    }).then(res => {
                        that.$Message.success('已刪除')
                        that.showTable()
                    })
                }
            })
        },
        exportCsv2 () {
            window.location.href = this.$axios.defaults.baseURL + "admin/download_pdf?uuid=" + this.detail.uuid 
            + "&action=delivery"
        },
        //下載訂單
        exportCsv () {
            window.location.href = this.$axios.defaults.baseURL + "admin/download_pdf?uuid=" + this.detail.uuid
            //return false

            let that = this
            that.downloadLoading = true
            document.getElementsByClassName("ivu-modal-close")[0].style.display = "none"
            let load = this.$Message.loading('下載中...')
            setTimeout(() => {
                
                let oDiv = document.getElementsByClassName("ivu-modal-content")[0]
                oDiv.setAttribute("id", "detail")
                let html = oDiv
                let contentWidth = html.clientWidth ; // 获得该容器的宽
                let contentHeight = html.clientHeight ; // 获得该容器的高
                html2Canvas(oDiv, {
                    scale: 3.5,allowTaint: true
                }).then(function (canvas) {
                    load()
                    that.downloadLoading = false
                    document.getElementsByClassName("ivu-modal-close")[0].style.display = 'block'
                    let pageData = canvas.toDataURL('image/jpeg', 1.0)
                    //一页 pdf 显示 html 页面生成的 canvas高度
                    let pageHeight = contentWidth
                    //未生成 pdf 的 html页面高度
                    let leftHeight = contentHeight
                    //上页面偏移
                    let position = 0
                    //左面偏移
                    let leftPosition = 0
                    //a4纸的尺寸[595.28,841.89]，html 页面生成的 canvas 在pdf中图片的宽高

                    let imgWidth = 590
                    let imgHeight = imgWidth / contentWidth * contentHeight
                    let PDF = new JsPDF('', 'pt', 'a4')
                    //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
                    //当内容未超过pdf一页显示的范围，无需分页
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'JPEG', leftPosition, 0, imgWidth, imgHeight)
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'JPEG', leftPosition, position, imgWidth, imgHeight)
                            leftHeight -= pageHeight
                            position -= 841.89
                            //避免添加空白页
                            if (leftHeight > 0) {
                                PDF.addPage()
                            }
                        }
                    }
                    // load()
                    PDF.save(that.detail.order_code + '.pdf')
                }).catch(e => {
                    console.log(e)
                    document.getElementsByClassName("ivu-modal-close")[0].style.display = 'block'
                    that.downloadLoading = false
                    laod()
                })
            },100)
            
        },
        changeStep (i) {
            this.step = i
        },
        changeDate (e, key,prop) {
            this[key][prop] = e
        },
        //獲取產品分類
        getCate () {
            this.$axios({
                url: "admin/category?page=1&offset=99999"
            }).then(res => {
                this.categories = res.data.data
                this.categories.forEach(cate => {
                    cate.commodity = []
                    this.getComm(cate)
                })
            })
        },
        format (n) {
            n = Number(n)
            var str = n.toString();
            str = str.replace(/[A-z]+/g, "")
            var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g
            let num = str.replace(reg,"$1,");
            return num
        },
    }
}
</script>

